import React from 'react';
import ReactDOM from 'react-dom/client';
// --- external imports -----

import { root } from '../index'
// --- parent imports -----

import assetsLoader from './assets';
// --- local imports -----

const rootElement = document.getElementById('root');
const splashscreenElement = document.getElementById('splashscreen-root');
const splashscreenPlaceholderElement = document.getElementById('splashscreen-placeholder');

const splashScreenRoot = ReactDOM.createRoot(splashscreenElement);

function startLoadingAssets() {
	rootElement.style.display = 'none';
	splashscreenPlaceholderElement.style.display = 'block';
	splashscreenElement.style.display = 'block';
	assetsLoader((d) => {
		console.log(
			'[SplashScreen]',
			d.category,
			d.groupName,
			d.status,
			`(${d.completed})`,
			`${d.progress}%`,
		);
	});
}

function mountGame() {
	import('../Game')
		.then(({ default: TradersGame }) => {
			root.render(<TradersGame />)
		});
}


export default function launchGame() {
	startLoadingAssets();

	import('./GameLoader')
		.then(({ default: GameLoader }) => {
			splashScreenRoot.render(<GameLoader onLoadComplete={mountGame} />)
		});
}

